import ServerPage from './serverPage';
export default ServerPage;
